module.exports = __webpack_public_path__ + "PerformanceReport-1b88798b1434ac0aae873da8610b6232.png";